import {
    SET_VEHICLES_LIST,
    UPDATE_VEHICLES_LIST,
    RESET_VEHICLES_LIST,
    BLOCK_VEHICLES_LIST,
} from '../actions/types';

const initialAuctionsState = {
    vehicles: [],
};

const auctionsReducer = (state = initialAuctionsState, { payload, type }) => {
    switch (type) {
        case SET_VEHICLES_LIST:
            return {
                ...state,
                vehicles: payload,
            };
        case UPDATE_VEHICLES_LIST:
            return {
                ...state,
                vehicles: state.vehicles.map(vehicle =>
                    vehicle?.WebSalesId === payload?.WebSalesId
                        ? {
                              ...vehicle,
                              ...payload,
                          }
                        : vehicle
                ),
            };
        case BLOCK_VEHICLES_LIST:
            return {
                ...state,
                vehicles: state.vehicles.map(vehicle =>
                    payload.vehicles.includes(vehicle?.WebSalesId)
                        ? { ...vehicle, IsBlocked: payload.status }
                        : vehicle
                ),
            };
        case RESET_VEHICLES_LIST:
            return {
                ...state,
                vehicles: initialAuctionsState.vehicles,
            };
        default:
            return state;
    }
};

export default auctionsReducer;
